export const removePersistedStorageFromCognitoObject = obj => {
  if (obj) {
    if (obj.storage) {
      obj = { ...obj, storage: { ...obj.storage, "persist:primary": {} } };
    }
    if (obj.pool && obj.pool.storage) {
      obj = {
        ...obj,
        pool: { storage: { ...obj.pool.storage, "persist:primary": {} } }
      };
    }
  }

  return obj;
};
